/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_2_Description_Ver2Inputs */

const en_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete the tasks to claim your big prize!`)
};

const ar_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل المهام لتحصل على جائزتك الكبرى!`)
};

const de_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigen Sie die Aufgaben, um Ihren großen Preis zu erhalten!`)
};

const es_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Completa las tareas para reclamar tu gran premio!`)
};

const fr_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminez les tâches pour obtenir votre grand prix !`)
};

const it_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le attività per ottenere il tuo grande premio!`)
};

const ja_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タスクを完了して、豪華賞品をゲットしましょう！`)
};

const ko_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미션을 완료하고 특별한 보상을 받으세요!`)
};

const pt_br_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua as tarefas para resgatar seu grande prêmio!`)
};

const ru_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполните задания, чтобы забрать свой большой приз!`)
};

const th_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำภารกิจให้เสร็จเพื่อรับรางวัลใหญ่ของคุณ!`)
};

const tr_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyük ödülünü almak için görevleri tamamla!`)
};

const zh_cn_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成任务，大奖就是你的啦！`)
};

const zh_tw_starter_challenge_phase_2_description_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Description_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成任務就能獲得大獎`)
};

/**
* | output |
* | --- |
* | "Complete the tasks to claim your big prize!" |
*
* @param {Starter_Challenge_Phase_2_Description_Ver2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_2_description_ver2 = /** @type {((inputs?: Starter_Challenge_Phase_2_Description_Ver2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_2_Description_Ver2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "de") return de_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "es") return es_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "it") return it_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "th") return th_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_2_description_ver2(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_2_description_ver2(inputs)
	return zh_tw_starter_challenge_phase_2_description_ver2(inputs)
});